module.exports = __webpack_public_path__ + "static/media/empire-bcbs.e88c92fe.png";